import { Injectable } from '@angular/core';
import { Observable, withLatestFrom } from 'rxjs';

import { AppConf, HttpService, isString, Logger, ProfileFacade } from '@contact/upgrade';

const TREE_SEARCH = 'v1/AKB/Bdr?userEmail=AKBaccess@owi-tech.com';
const TEXT_SEARCH = 'v1/AKB/AideReponseFt?userEmail=AKBaccess@owi-tech.com&texte=';
const RESPONSE_MODEL_SEARCH = 'v1/AKB/Mdr?mdrNum=';
const SUGGESTION_URL = 'v1/AKB/AideReponse?listeTypes=M&mdrC=1&idExt=';
const KO_RESPONSE = 'v1/AKB/AKBEvt/AgentNotification/';
const DOWNLOAD_FILE = 'file/download?';

@Injectable({
  providedIn: 'root',
})
export class KnowledgeBaseOwiApiService {
  owiBaseUrl: string;

  constructor(
    private readonly http: HttpService,
    private readonly appConf: AppConf,
    private readonly profileFacade: ProfileFacade,
    private readonly logger: Logger
  ) {
    this.profileFacade.profile$.pipe(withLatestFrom(this.appConf)).subscribe(([profile, appConf]) => {
      if (isString(appConf.knowledgeBaseServiceUrl)) {
        this.owiBaseUrl = appConf.knowledgeBaseServiceUrl;
        this.logger.info('Will use [' + this.owiBaseUrl + '] as knowledgeBaseServiceUrl.');
      } else {
        if (profile.domainId && appConf.knowledgeBaseServiceUrl?.hasOwnProperty(profile.domainId)) {
          this.owiBaseUrl = appConf.knowledgeBaseServiceUrl[profile.domainId];
          this.logger.info('Will use [' + this.owiBaseUrl + '] as domain knowledgeBaseServiceUrl.');
        } else {
          this.logger.warn('The domain uuid [' + profile.domainId + '] knowledgeBaseServiceUrl is not set !');
        }
      }
    });
  }

  public getTree(): Observable<Object> {
    return this.http.get(this.owiBaseUrl + TREE_SEARCH);
  }

  public getSuggestedResults(mediaExternalId: string | number): Observable<Object> {
    return this.http.get(this.owiBaseUrl + SUGGESTION_URL + mediaExternalId);
  }

  public getDocument(id: string): Observable<Object> {
    return this.http.get(this.owiBaseUrl + RESPONSE_MODEL_SEARCH + id);
  }

  public getTextSearchResults(text: string): Observable<Object> {
    return this.http.get(this.owiBaseUrl + TEXT_SEARCH + text);
  }

  public downloadFile(path: string): Observable<Object> {
    return this.http.get(this.getFileUrlByPath(path), { responseType: 'blob' });
  }

  public downloadFileByResponseModelIdAndFileName(responseModelId: string, name: string): Observable<Object> {
    return this.http.get(this.getFileUrlByResponseModelIdAndFileName(responseModelId, name), { responseType: 'blob' });
  }

  public getFileUrlByPath(path: string): string {
    return this.owiBaseUrl + DOWNLOAD_FILE + 'url=' + path;
  }

  public getFileUrlByResponseModelIdAndFileName(responseModelId: string, name: string): string {
    return this.owiBaseUrl + DOWNLOAD_FILE + 'mdrNum=' + responseModelId + '&fileName=' + name;
  }

  public sendKoNotification(mediaExternalId: string, code: string): Observable<Object> {
    return this.http.post(this.owiBaseUrl + KO_RESPONSE, {
      idExt: mediaExternalId,
      code: code,
      comment: 'KO',
      userEmail: 'noEmail',
    });
  }

  public getOwiBaseUrl(): string {
    return this.owiBaseUrl ? this.owiBaseUrl : '';
  }
}
